import { styled } from '@mui/system';
import { Typography } from '@mui/material';

interface PriceProps {
  type: 'normal' | 'insurance' | 'strikethrough';
}

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '100px',
  paddingBottom: 0,
  padding: '0 10px 0px 16px',
});

const TitleTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});
const DetailsTextTypography = styled(Typography)({
  fontSize: '12px',
  letterSpacing: '0.4px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  marginTop: '3px',
  color: '#757475',
  span: {
    color: '#414046',
  },
});

const DetailsPriceDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
});

const DetailsPriceTypographyBold = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'type',
})<PriceProps>(({ type }) => ({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color:
    type == 'normal' ? '#414046' : type == 'insurance' ? '#731EFF' : '#CBCBCB',
  textDecoration: type == 'strikethrough' ? 'line-through' : 'none',
}));

const DetailsPriceTypographyLight = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'type',
})<PriceProps>(({ type }) => ({
  fontFamily: 'Poppins',
  fontWeight: type == 'insurance' ? 500 : 300,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color:
    type == 'normal' ? '#414046' : type == 'insurance' ? '#731EFF' : '#CBCBCB',
  textDecoration: type == 'strikethrough' ? 'line-through' : 'none',
}));

const ColumnDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

export {
  RootDiv,
  TitleTypography,
  DetailsTextTypography,
  DetailsPriceDiv,
  DetailsPriceTypographyBold,
  DetailsPriceTypographyLight,
  ColumnDiv,
};
